import {  Button } from '@mui/material';
import React from 'react';
import { VIEW_MODE } from '../../../consts/enums';
import { Pencil } from '../../../icons/pencil';
import TalentsAvatarImages from './AvatarImage';
import AvatarWithIcon from './AvatarWithIcon';
import { UploadImage } from './UploadImage';

type TalentAvatarProps = {
  handleInputUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void,
  alt: string,
  profileImage: string,
  viewMode: ViewMode
};

const style = {
  width: 64,
  height: 64,
  p: 0,
  backgroundColor: '#6B7280',
  emptyStateIcon: {
    borderRadius: '50%',
    sx: {
      bgColor: 'primary.main',
    },
  },
  fontSize: 25,
  badge: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  },
  profileImageViewMode: {
    borderRadius: '50%',
    width: 64,
    height: 64,
  },
} as const;

export const AvatarWithEdit = ({
  alt,
  profileImage,
  handleInputUploadImage,
  viewMode,
}:TalentAvatarProps): JSX.Element | null => {
  if (viewMode === VIEW_MODE.EDITABLE) {
    return (
      <form name="file" encType="multipart/form-data">
        <Button
          style={ { background: 'unset' } }
          variant="contained"
          component="label"
        >

          <input
            type="file"
            name="file"
            accept="image/*"
            onChange={ handleInputUploadImage }
            hidden
          />
          {profileImage?.length > 0 ? (

            <TalentsAvatarImages
              style={ style }
              alt={ alt }
              src={ profileImage }
              profileIcon={ (
                <>
                  <AvatarWithIcon>
                    <Pencil sx={ {
                      color: '#fff',
                      fontSize: 20,
                    } }
                    />
                  </AvatarWithIcon>
                </>
              ) }
            />
          ) : (
            <UploadImage
              alt={ alt }
              profileImage={ profileImage }
              handleInputUploadImage={ handleInputUploadImage }
              isLoading={ false }
              isDisabled={ false }
            />
          )}
        </Button>
      </form>
    );
  }

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    <img
      src={ profileImage }
      alt={ alt }
      style={ style.profileImageViewMode }
    />
  );
};
